import React from 'react';

export default function Chevron (props) {
    return (
        <svg className={props.className} fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="8.075" height="14.165" viewBox="0 0 8.075 14.165">
            <path id="Path_20" data-name="Path 20" d="M97.429,7.784l6.091,6.091a.992.992,0,0,0,1.4-1.4L99.533,7.082l5.389-5.389a.992.992,0,0,0-1.4-1.4L97.429,6.381a.992.992,0,0,0,0,1.4Z" transform="translate(-97.139 0)" />
        </svg>
    );
}